import { PlanningEventDependencyGeneratedEntity } from "./generated/PlanningEventDependencyGeneratedEntity";
import { PlanningEventEntity } from "./PlanningEventEntity";
import { PlanningEventGroupEntity } from "./PlanningEventGroupEntity";

export abstract class PlanningEventDependencyEntity extends PlanningEventDependencyGeneratedEntity {
    get predecessor(): PlanningEventEntity | PlanningEventGroupEntity | null {
        return this.predecessorEventGroup ?? this.predecessorEvent;
    }

    set predecessor(value: PlanningEventEntity | PlanningEventGroupEntity) {
        if (value instanceof PlanningEventGroupEntity) {
            this.predecessorEventGroup = value;
            this.predecessorEvent = null as any;
        } else {
            this.predecessorEvent = value;
            this.predecessorEventGroup = null;
        }
    }

    get successor(): PlanningEventEntity | PlanningEventGroupEntity | null {
        return this.successorEventGroup ?? this.successorEvent;
    }

    set successor(value: PlanningEventEntity | PlanningEventGroupEntity) {
        if (value instanceof PlanningEventGroupEntity) {
            this.successorEventGroup = value;
            this.successorEvent = null as any;
        } else {
            this.successorEvent = value;
            this.successorEventGroup = null;
        }
    }
}
